<template>
    <v-snackbar
        v-model="showSnackbar"
        top center :timeout=10000
        :color="snackbarColor"
        auto-height>
        <v-icon dark v-if="snackbarColor == 'error-banner'" class="pr-1">warning</v-icon>
        <v-icon dark v-else class="pr-1">done</v-icon>
        <b v-text="snackbarMessage"></b>
        <v-btn :color="snackbarColor" @click="$emit('close')" class="black--text snackbar-button">Close</v-btn>
    </v-snackbar>
</template>
<script>
import Vue from 'vue';
export default {
    name: 'Snackbar',
    props:{
        snackbarColor:{
            type:String,
            default:null
        },
        snackbarMessage:{
            type:String,
            default:null
        }
    },
    data () {
        return {
            showSnackbar : true,
        }
    }
}
</script>
<style scoped lang="scss">

.snackbar-button {
    box-shadow: none ;
    }
</style>
